<template>
  <v-menu
    :close-on-content-click="false"
    :disabled="readonly || disabled"
    full-width
    lazy
    max-width="300px"
    min-width="300px"
    offset-y
    transition="scale-transition"
    v-model="menu"
  >
    <v-text-field
      ref="dateTime"
      :autofocus="autofocus"
      :clearable="!readonly"
      :disabled="disabled"
      :error="error"
      :hint="hint?hint:'格式：YYYY-MM-DD hh:mm'"
      :label="label"
      :prepend-icon="hideIcon ? '':'$vuetify.icons.datetime'"
      :rules="[...rules, datetimeRule]"
      persistent-hint
      slot="activator"
      :readonly="!canUseNativeKeyboard"
      v-model="datetimeFormatted"
    ></v-text-field>
    <v-card>
      <v-card-text class="px-0 py-0">
        <v-layout align-end justify-center row wrap>
          <!--<v-flex xs12><h1>{{datetimeFormatted}}, {{date}}, {{time}}</h1></v-flex>-->
          <!--<v-flex xs6>-->
          <!--<v-time-picker-->
          <!--v-if="menu"-->
          <!--class="flat"-->
          <!--no-title-->
          <!--v-model="time"-->
          <!--format="24hr"-->
          <!--&gt;</v-time-picker>-->
          <!--</v-flex>-->
        </v-layout>
        <v-divider></v-divider>
        <v-container class="py-2" fluid grid-list-md>
          <v-layout align-center justify-end row>
            <!-- <v-flex class="grey&#45;&#45;text text-xs-center subheading" xs4>{{dateFormatted}}</v-flex>-->
            <v-flex xs5>
              <v-select
                :items="daySelect"
                ref="day"
                v-model="day"
              ></v-select>
            </v-flex>
            <span class="mx-2">:</span>
            <v-flex xs5>
              <v-select
                :items="hourSelect"
                ref="hour"
                v-model="hour"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-layout></v-layout>
    </v-card>
  </v-menu>
</template>

<script>
import {time} from '../../ladmin/utils/time'
let datePattern = /^\d{4}-\d\d-\d\d$/i
let timePattern = /^(\d\d):(\d\d)$/i
let datetimePattern = /^(\d{4}-\d\d-\d\d) (\d\d:\d\d)$/i

export default {
  name: 'SelectDatetimeWx',
  props: {
    minDate: {type: String},
    maxDate: {type: String},
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    hint: {
      type: String,
      default: '',
    },
    value: {},
    autofocus: {type: Boolean, default: false},
  },
  data: () => ({
    date: null,
    day: '',
    hour: '',
    // dateFormatted: '',
    timeFormatted: '',
    menu: false,
    datetimeRule: v => !v || /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (20|21|22|23|[0-1]\d):[0-5]\d$/i.test(v) || '时间格式不正确，格式：YYYY-MM-DD hh:mm',
    datetimeFormatted: '',
  }),
  computed: {
    daySelect () {
      return ['1']
    },
    hourSelect () {
      return ['2']
    },
    canUseNativeKeyboard () {
      // menu为true的时候，下次点击关闭，此时可以弹出键盘
      return !this.menu
    },
    time: {
      get () {
        if (this.hour && this.minute) {
          return `${this.hour}:${this.minute}`
        }
        else {
          return ''
        }
      },
      set (val) {
        let group = timePattern.exec(val)
        if (group) {
          this.hour = group[1]
          this.minute = group[2]
        }
        else {
          this.hour = ''
          this.minute = ''
        }
      }
    },
    dateFormatted () {
      let group = /^\d{4}-\d\d-\d\d/i.exec(this.datetimeFormatted)
      if (group) {
        let date = group[0]
        return this.parseDate(date)
      }
      else {
        return 'YYYY-MM-DD'
      }
    },
    inputComplete () {
      return timePattern.test(this.time) && datePattern.test(this.formatDate(this.date))
    }
  },
  watch: {
    // datetime () {
    //   this.datetimeFormatted = this.datetime
    // },
    hour (val, oldVal) {
      if (/^\d\d$/i.test(val) && this.$refs.minute && (oldVal.length < 2)) {
        // console.log('get focus', this.$refs.minute)
        this.$refs.minute.focus()
      }
      else if (/^\d\d(\d)+$/i.test(val)) {
        this.hour = val.slice(-1)
      }
    },
    minute (val, oldVal) {
      if (/^\d\d(\d)+$/i.test(val)) {
        this.minute = val.slice(-1)
      }
    },
    date (val, oldVal) {
      if (!this.time && val) {
        // console.log('new time', this.nowTime())
        this.time = '00:00'
        // this.time = this.nowTime()
      }
      this.$nextTick(() => {
        if (this.$refs.hour) {
          this.$refs.hour.focus()
        }
      })
      this.datetimeFormatted = this.computeDatetime(val)
      // console.log('set date', this.datetimeFormatted, this.date)
    },
    time (val) {
      this.datetimeFormatted = this.computeDatetime(val)
      // console.log('set time', this.datetimeFormatted)
    },
    value (val) {
      this.datetimeFormatted = val
      // console.log('input', val)
    },
    datetimeFormatted (val) {
      if (val === null) {
        this.date = ''
        this.time = ''
      }
      let group = datetimePattern.exec(val)
      if (group) {
        // console.log('complete', val)
        let date = group[1]
        let time = group[2]
        this.date = this.parseDate(date)
        this.time = time
        this.submit()
      }
      else if (!val) {
        this.submit()
        // console.log(val)
        // this.date = null
        // this.time = null
      }
    }
  },
  methods: {
    reFocus () {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$refs.input.blur()
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      }
    },
    wheelMinute (e = {}) {
      if (!e.wheelDelta) return
      let ref = this.$refs.minute || {}
      if (!ref.isFocused) return
      let delta = e.wheelDelta > 0 ? 1 : -1
      this.addMin(delta)
    },

    wheelHour (e = {}) {
      if (!e.wheelDelta) return
      let ref = this.$refs.hour || {}
      if (!ref.isFocused) return
      let delta = e.wheelDelta > 0 ? 1 : -1
      this.addHour(delta)
    },
    addMin (delta) {
      let s = time.addMinute(this.datetimeFormatted, delta, time.DT)
      if (s) {
        this.datetimeFormatted = s
      }
      // let d = new Date(year, month - 1, day)
      // d.setDate(d.getDate() + this.maxDurationDay)
      // return time.stringify(d, time.D)
    },
    addHour (delta) {
      // console.log('add hour', delta)
      let s = time.addHour(this.datetimeFormatted, delta, time.DT)
      if (s) {
        this.datetimeFormatted = s
      }
    },
    nowTime () {
      let t = new Date()
      return `${t.getHours().toString().padStart(2, '0')}:${t.getMinutes().toString().padStart(2, '0')}`
    },
    computeDatetime () {
      if (timePattern.test(this.time) && datePattern.test(this.formatDate(this.date))) {
        // console.log('all')
        return this.formatDate(this.date) + ' ' + this.time
      }
      else if (datePattern.test(this.formatDate(this.date))) {
        // console.log('date check')
        return this.formatDate(this.date)
      }
      else if (timePattern.test(this.time)) {
        // console.log('time check')
        return 'YY-MM-DD' + ' ' + this.time
      }
      else {
        // console.log('none check', this.date, this.time)
        return ''
      }
    },
    submit () {
      // console.log('submit', this.dateFormatted)
      this.$emit('input', this.datetimeFormatted)
    },
    formatDate (date) {
      if (!date) {
        // if (this.dateFormatted)
        return null
      }
      const [year, month, day] = date.split('-')
      return `${year}-${month}-${day}`
    },
    parseDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      // if (!(year && month && day)) return null
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
  created () {
    this.datetimeFormatted = this.value
  }
}
</script>
<style scoped>
  .flat {
    box-shadow: none !important;
  }
</style>
